import { Flow_0_0_2 } from '@flexus/core';

export const SIL_7: Flow_0_0_2 = {
	id: '7',
	name: 'claim_complete',
	itemType: 'flow',
	header: {
		title: 'Claim Completed',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'Placeholder'
		},
		viewRoles: {
			0: 'Placeholder'
		}
	},
	startNode: '',
	nodes: {}
};
